module.exports = __webpack_public_path__ + "static/special-needs-planning-hero-mobile.9d1406d0.webp";